import React, { useState, useEffect } from "react";
import { BASE_URL } from "../env";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import filterFactory, {
	textFilter,
	selectFilter,
} from "react-bootstrap-table2-filter";
import ToolkitProvider, {
	CSVExport,
	Search,
} from "react-bootstrap-table2-toolkit";

const { SearchBar } = Search;
const { ExportCSVButton } = CSVExport;

const Hybridexamscore = () => {
	const [courseData, setCourseData] = useState([]);
	const [tabledata, settabledata] = useState([]);

	useEffect(() => {
		fetch(BASE_URL + "/getallexams")
			.then((res) => res.json())
			.then((data) => {
				console.log(data);
				setCourseData(data?.exams);
			});
	}, []);

	let newdata = [];
	useEffect(() => {
		for (var i = 0; i < courseData.length; i++) {
			newdata.push({
				sno: i + 1,

				QuizInstruction: courseData[i],
				instructionmain: courseData[i],
				startdate: courseData[i]?.startdate.split("T")[0],
				nameoftheExam: courseData[i],
				attempts: courseData[i],
				enddate: courseData[i]?.enddate.split("T")[0],
				coursename: courseData[i]?.courseId.name,
				//   questions:courseData[i]?.questions.length,
				//   id:courseData[i]?._id,
			});
		}
		settabledata(newdata);
		// console.log(JSON.stringify(newdata));
	}, [courseData]);

	let priceFilter;

	const columns = [
		{
			dataField: "sno",
			text: "S No.",
			sort: true,

			headerStyle: () => {
				return {
					width: "5%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
				style: {
					height: "5px",
				},
			}),
		},

		{
			dataField: "nameoftheExam",
			text: "Name of the Exam",
			sort: true,
			formatter: (cell) => (
				<a href={`/Hybridexameachresult/${cell._id}`}>
					{" "}
					{cell.nameoftheExam}{" "}
				</a>
			),
			filter: textFilter({
				style: {
					height: "5px",
				},
			}),
			headerStyle: () => {
				return {
					width: "10%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
		},
		{
			dataField: "coursename",
			text: "Course Name",
			sort: true,

			filter: textFilter({
				style: {
					height: "5px",
				},
			}),
			headerStyle: () => {
				return {
					width: "10%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
		},
		{
			dataField: "attempts",
			text: "Attempts",
			sort: true,
			formatter: (cell) => (
				<a href={`/Hybridexameachresult/${cell._id}`}>
					{" "}
					{cell.attempts}{" "}
				</a>
			),
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
				style: {
					height: "5px",
				},
			}),
			headerStyle: () => {
				return {
					width: "5%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
		},
		{
			dataField: "startdate",
			text: "Start date",
			sort: true,
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
				style: {
					height: "5px",
				},
			}),
			headerStyle: () => {
				return {
					width: "10%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
		},
		{
			dataField: "enddate",
			text: "End date",
			sort: true,
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
				style: {
					height: "5px",
				},
			}),
			headerStyle: () => {
				return {
					width: "10%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
		},
		{
			dataField: "QuizInstruction",
			text: "Quiz Instruction",
			sort: true,
			formatter: (cell) => (
				<a href={`/Hybridexameachresult/${cell._id}`}>
					{" "}
					{cell.QuizInstruction}{" "}
				</a>
			),
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
				style: {
					height: "5px",
				},
			}),
			headerStyle: () => {
				return {
					width: "10%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
		},
		{
			dataField: "instructionmain",
			text: "Instruction Main",
			sort: true,
			formatter: (cell) => (
				<a href={`/Hybridexameachresult/${cell._id}`}>
					{" "}
					{cell.instructionmain}{" "}
				</a>
			),
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
				style: {
					height: "5px",
				},
			}),
			headerStyle: () => {
				return {
					width: "10%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
		},
	];

	return (
		<div style={{ margin: "20px" }}>
			<h1 style={{ textAlign: "center", fontWeight: "900" }}>
				Quiz Exams
			</h1>

			<ToolkitProvider
				keyField={"sno"}
				data={tabledata}
				columns={columns}
				exportCSV={{
					fileName: "quizexam_results.csv",
					blobType: "text/csv;charset=ansi",
					onlyExportFiltered: true,
					exportAll: false,
				}}
				search
			>
				{(props) => (
					<div>
						<div className="d-flex justify-content-between">
							<ExportCSVButton
								{...props.csvProps}
								className="btn btn-md bg-warning my-2 "
								style={{
									borderRadius: "10px",
									marginLeft: "20px",
								}}
							>
								Download All Data
							</ExportCSVButton>
							<SearchBar
								{...props.searchProps}
								style={{
									width: "300px",
									height: "5px",
									marginRight: "20px",
								}}
							/>
						</div>
						<br />
						<BootstrapTable
							{...props.baseProps}
							filter={filterFactory()}
							// condensed
							bootstrap4
							loading
							// classes="text-white"
							striped
						/>
					</div>
				)}
			</ToolkitProvider>
		</div>
	);
};

export default Hybridexamscore;
